import { 
	InnerBlocks, 
	RichText,
	useBlockProps
} from '@wordpress/block-editor';

import { __ } from '@wordpress/i18n';
import { blockColumns } from './templates';

const INNER_BLOCKS_TEMPLATE = [
		blockColumns
]



const Edit = ({attributes, setAttributes}) => {
	const blockProps = useBlockProps();
	const {

		headline,
		description,


	} = attributes;	
	return (
		<div className="wp-block" >
			<div { ...blockProps } className='alignfull'>
				<RichText
					tagName="h3"
					value={ headline }
					onChange={ ( headline ) => setAttributes( { headline } ) }
					placeholder={ __( 'Überschrift', 'ssvreutlingen' ) }
				/>
				<RichText
					tagName="p"
					value={ description }
					onChange={ ( description ) => setAttributes( { description } ) }
					placeholder={ __( 'Überschrift', 'ssvreutlingen' ) }
				/>
			</div>
			<div>
			<InnerBlocks
				classname="ssv-table" 
				template={ INNER_BLOCKS_TEMPLATE }
				templateLock='all'
			/>
			</div>
		</div>


	);  
};

export default Edit;
